module.exports = __webpack_public_path__ + "img/005-avatar-4.7962c704.png";